module.exports = __webpack_public_path__ + "img/es-flag.7120b1b0.png";